// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D5tZQ","subtitle":"styles_subtitle__zacuS","paragraph":"styles_paragraph__6+uxe"};